// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"529":"6afbb78c","710":"44932b5a","878":"115c8057","983":"d91c541c"}[chunkId] + ".chunk.js");